import { useMutation } from 'react-query';
import { enqueueSnackbar } from 'notistack';

import { putEncAfterBlitz } from 'api/encounters/putEncAfterBlitz';

export const usePutEncAfterBlitz = () => {
  return useMutation({
    mutationFn: putEncAfterBlitz,
    onSuccess: () => {
      enqueueSnackbar('Pest Sighting resolved successfully', { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar('Failed to complete encounter', { variant: 'error' });
    },
  });
};
